// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3lV82","loaderOuter":"PageOverlayLoader_loaderOuter__2Cdpd"};